import CTNEllipsis from '@ctn/ui/components/ctn-ellipsis';
import { CTNIconTooltip } from '@ctn/ui/components/ctn-icon';

import TextIcon from '@/components//TextIcon';

import type { IRepresentante, ISujetoListado } from '@/interfaces/model/don.interface';
import { getFullName } from '@/utils/string/string';
import type { CustomColumnDef } from '@ctn/ui/types/ctn-table';


const getColumns = ({
	onDelete,
	onEdit,
	onView,
	onSubsanar,
	hasColumnSubsanacion,
}: {
	onDelete?: (value: ISujetoListado) => void;
	onEdit?: (value: ISujetoListado) => void;
	onView?: (value: ISujetoListado) => void;
	onSubsanar?: (value: ISujetoListado) => void;
	hasColumnSubsanacion?: boolean;
}) => {
	const columns: Array<CustomColumnDef<ISujetoListado>> = [
		{
			accessorKey: 'tipoPersona',
			header: 'Tipo de persona',
			enableSorting: false,
			th: {
				width: 140,
			},
			cell({ getValue }) {
				const value = getValue() as ISujetoListado['tipoPersona'];
				return <CTNEllipsis content={value.descripcion} />;
			},
		},
		{
			accessorKey: 'tipoIntervencion',
			header: 'Tipo de inter.',
			enableSorting: false,
			th: {
				width: 120,
			},
			cell({ getValue }) {
				const value = getValue() as ISujetoListado['tipoIntervencion'];
				return <CTNEllipsis content={value.descripcion} />;
			},
		},
		{
			accessorKey: 'tipoDocumentoIdent',
			header: 'Tipo Doc.',
			enableSorting: false,
			th: {
				width: 100,
			},

			cell({ getValue }) {
				const value = getValue() as ISujetoListado['tipoDocumentoIdent'];
				return <CTNEllipsis content={value.descripcion} />;
			},
		},
		{
			accessorKey: 'numeroDocumento',
			header: 'Nº Doc.',
			enableSorting: false,
			th: {
				width: 120,
			},

			cell({ getValue }) {
				return <CTNEllipsis content={getValue() as string} />;
			},
		},
		{
			accessorKey: 'name',
			header: 'Nombre',
			enableSorting: false,
			responsive: {
				sizeColumn: 'full'
			},
			cell({ row }) {
				const { nombre, apellido1RacSoc, apellido2, representantes } = row.original;
				const fullName = getFullName(nombre, apellido1RacSoc, apellido2);
				const hasRepresentantes = Boolean(representantes && representantes?.length > 0);
				const getListRepresentantes = () =>
					hasRepresentantes
						? (representantes as IRepresentante[]).map(
							({ nombre, apellido1RacSoc, apellido2, numeroDocumento }) =>
								`${numeroDocumento} - ${getFullName(nombre, apellido1RacSoc, apellido2)}`,
						)
						: [];
				return (
					<TextIcon
						description={fullName}
						iconRight={
							hasRepresentantes
								? {
									icon: 'user',
									color: 'blue-50',
									tooltip: {
										content: (
											<ul>
												{getListRepresentantes().map((item) => (
													<li key={item}>{item}</li>
												))}
											</ul>
										),
										place: 'top',
									},
								}
								: undefined
						}
					/>
				);
			},
		},
	];

	if (hasColumnSubsanacion) {
		columns.unshift({
			accessorKey: 'subsanacionPendiente',
			header: 'Subs.',
			enableSorting: false,
			th: {
				width: 60,
			},
			responsive: {
				sizeColumn: 'full'
			},
			cell({ getValue }) {
				return getValue() as ISujetoListado['subsanacionPendiente'] ? (
					<CTNIconTooltip icon="warning" color="orange-50" tooltip={{ content: 'Subsanación pendiente' }} />
				) : (
					<></>
				);
			},
		});
	}

	return columns;
};

export { getColumns };
